import { Card, CardBody, Col } from 'reactstrap'
import { VerticalStyles } from '../../../../../Utils/Constants'
import CommonCardFooter from '../Common/CommonCardFooter'
import { verticalStyleData } from '../../../../../Data/Forms/FormsControl/MegaOption/MegaOption'
import VerticalStyleForm from './VerticalStyleForm'
import CardHeaderCommon from '../../../../../Utils/CommonComponents/CardHeaderCommon'

const VerticalStyle = () => {
  return (
    <Col sm="12" xxl="6" className="box-col-12">
      <Card className="height-equal">
        <CardHeaderCommon title={VerticalStyles} span={verticalStyleData} />
        <CardBody className="mb-5">
          <VerticalStyleForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="primary" color2="light" />
      </Card>
    </Col>
  )
}

export default VerticalStyle